import { Directive, HostListener, ElementRef, Input, Output, EventEmitter } from '@angular/core'

// this needs to coexist along ClDropDirective until every component using it is migrated from angularJS
@Directive({
    selector: '[clDropElement]'
})
export class ClDropDirective {

    @Output() clDrop = new EventEmitter();
    @Output() clOver = new EventEmitter();
    @Output() clLeave = new EventEmitter();

    @HostListener('drop', ['$event'])
    onDrop($event) {
        this.clDrop.emit($event);
    }

    @HostListener('dragover', ['$event'])
    onDragOver($event) {
        this.clOver.emit($event);
    }

    @HostListener('dragleave', ['$event'])
    onLeave($event) {
        this.clLeave.emit($event);
    }

}
